export class DataContext {
	filtri;

	constructor() {
		this.filtri = {};
	}
}



// WEBPACK FOOTER //
// ./src/app/_models/data-context.ts